import React from 'react';

const BaseMenuOptions = ({ items = [], activeItemId = '', onSelect }) => (
  <>
    {items.map((item) => (
      <button
        key={item.id}
        className={`nav-item ${activeItemId === item.id ? 'active' : ''}`}
        onClick={() => onSelect?.(item)}
      >
        <i className={item.icon}></i>
        <span>{item.label}</span>
      </button>
    ))}
  </>
);

export default BaseMenuOptions;
